import Main from '@/views/administracion/configuracion/catalogos/deducciones/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/deducciones/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const deducciones = [
  {
    path: 'deducciones',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoDeducciones',
        path: '/',
        meta: {
          title: 'Deducciones',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default deducciones;
